<template>
  <div class="contianer">
    <page-header></page-header>
    <div class="section section--banner">
      <div class="section-container">
        <div class="img-host">
          <img src="../../assets/business_host.png" alt="">
        </div>
        <div class="img-wrapper">
          <img class="img-pi" src="../../assets/business_pi.png" alt="">
          <img class="img-pi-service" src="../../assets/business_pi_service.png" alt="">
        </div>
        <a class="btn-contact" href="https://work.weixin.qq.com/kfid/kfcb5dce99eda4830ae" target="_blank">联系我们</a>
        <img class="img-decoration" src="../../assets/business_banner_decoration.png" alt="">
      </div>
    </div>
    <div class="section section--service">
      <div class="top"></div>
      <div class="section-container">
        <div class="function-list">
          <div class="function">
            <div class="function__img">
              <img src="../../assets/business_service_news.png" alt="">
            </div>
            <div>
              <h3>最新动态</h3>
              <p>时间节省99%、成本降低80%，中国3800万家...</p>
            </div>
          </div>
          <div class="function">
            <div class="function__img">
              <img src="../../assets/business_service_book.png" alt="">
            </div>
            <div>
              <h3>区块链白皮书</h3>
              <p>派链技术实践白皮书重磅发布</p>
            </div>
          </div>
          <div class="function">
            <div class="function__img">
              <img src="../../assets/business_service_product.png" alt="">
            </div>
            <div>
              <h3>产品专区</h3>
              <p>“数字卡包”小程序上线，区块链技术提升品质...</p>
            </div>
          </div>
        </div>
        <h1 class="title">全面、专业、高效的区块链产品服务</h1>
        <h2 class="subtitle">智臻链为企业和开发者提供全方位、全生命周期的一站式区块链解决方案</h2>
        <div class="service-list">
          <div class="service">
            <h3>Chain引擎</h3>
            <p>面向企业通用应用场景的区块链框架系统，支持JAVA的SDK与合约代码，能够作为企业级区块链基础设施，为商业应用创新提供高效、灵活和安全的解决方案。</p>
            <a href="javascript:;">
              <div>
                <p>了解详情</p>
                <img src="../../assets/youjiantou.png" alt="">
              </div>
            </a>
          </div>
          <div class="service">
            <h3>BaaS平台</h3>
            <p>JD BaaS平台提供全面的区块链即服务功能，从企业和开发者角度出发，提供多种部署形式，既能灵活部署，又可安全易用，基于流行的kubernetes技术，提供高可靠可扩展的区块链平台。</p>
            <a href="javascript:;">
              <div>
                <p>了解详情</p>
                <img src="../../assets/youjiantou.png" alt="">
              </div>
            </a>
          </div>
          <div class="service">
            <h3>派链开放联盟网络平台</h3>
            <p>秉承BaaS平台特点建立的开放联盟网络，能够提供API、SDK，合约IDE及一系列合约模版、解决方案，通过引入权威节点为入驻企业或个人提供无需建链的区块链生态服务。</p>
            <a href="javascript:;">
              <div>
                <p>了解详情</p>
                <img src="../../assets/youjiantou.png" alt="">
              </div>
            </a>
          </div>
          <div class="service">
            <h3>派链电子合同平台</h3>
            <p>派链合同提供即开即用的电子合同服务，无论是在桌面端还是移动端均可随时随地完成合同签约；也支持电子合同全流程API服务，满足多样化的需求。</p>
            <a href="javascript:;">
              <div>
                <p>了解详情</p>
                <img src="../../assets/youjiantou.png" alt="">
              </div>
            </a>
          </div>
          <div class="service">
            <h3>派链防伪追溯平台</h3>
            <p>派链防伪追溯平台记录商品从原产地到消费者全生命周期每个环节的重要数据，通过物联网和区块链技术，保障数据的不可篡改性和隐私保护性，为企业提供产品流通数据的全流程追溯能力。</p>
            <a href="javascript:;">
              <div>
                <p>了解详情</p>
                <img src="../../assets/youjiantou.png" alt="">
              </div>
            </a>
          </div>
          <div class="service">
            <h3>派链数字存证平台</h3>
            <p>基于领先的派链底层技术，结合可信时间戳、权威CA等，对视频、图文、协议、交易过程等进行区块链存证，并同步司法机构，保障数据完整性、真实性、可信性。</p>
            <a href="javascript:;">
              <div>
                <p>了解详情</p>
                <img src="../../assets/youjiantou.png" alt="">
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="section section--solution">
      <div class="section-container">
        <h1 class="title">支持多业务场景的区块链解决方案</h1>
        <div class="solution-wrapper">
          <div class="solution-menu">
            <p class="active">供应链</p>
            <p>金融</p>
            <p>疫苗追溯</p>
            <p>公共事务</p>
            <p>知识产权</p>
            <p>二手商品买卖</p>
            <p>公益</p>
            <p>技术合作</p>
          </div>
          <div class="solution-list">
            <div class="solution">
              <div>
                <h3>供应链</h3>
                <p class="solution__summary">
                  供应链由众多参与主体构成，存在大量交互协作，信息被离散地保存在各自环节和系统中，缺乏透明度。区块链技术通过提供完整流畅的信息流、不可篡改的签名认证机制，可以实现多中心化的精准追溯和充分信任，天然地适用于供应链管理。
                </p>
                <a href="javascript:;">
                  <div>
                    <p>了解更多</p>
                    <img src="../../assets/youjiantou.png" alt="">
                  </div>
                </a>
              </div>
              <div class="solution__img">
                <img src="../../assets/business_solution_supplychain.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section section--honor">
      <div class="section-container">
        <h1 class="title">成绩与荣誉</h1>
        <div class="honor-list">
          <div class="honor">
            <div class="honor__img">
              <img src="../../assets/business_honor_world.png" alt="">
            </div>
            <p class="honor__title">业界荣誉</p>
            <p class="honor__count">20000+</p>
            <p class="honor__summary">区块链品牌派链多次荣膺业界技术大奖</p>
          </div>
          <div class="honor">
            <div class="honor__img">
              <img src="../../assets/business_honor_zhuanli.png" alt="">
            </div>
            <p class="honor__title">专利</p>
            <p class="honor__count">300+</p>
            <p class="honor__summary">加大区块链技术研发投入，硬核知产全球领先</p>
          </div>
          <div class="honor">
            <div class="honor__img">
              <img src="../../assets/business_honor_hangye.png" alt="">
            </div>
            <p class="honor__title">行业标准</p>
            <p class="honor__count">35+</p>
            <p class="honor__summary">积极参与标准和行业研究，为产业化规范应用贡献智慧</p>
          </div>
          <div class="honor">
            <div class="honor__img">
              <img src="../../assets/business_honor_ceping.png" alt="">
            </div>
            <p class="honor__title">权威评测</p>
            <p class="honor__count">20000+</p>
            <p class="honor__summary">经权威机构评测，每秒交易处理数量可达20000+TPS</p>
          </div>
        </div>
      </div>
    </div>
    <div class="section section--case">
      <div class="section-container">
        <h1 class="title">帮助众多客户成功上区块链</h1>
        <div class="case-wrapper">
          <div class="case-menu">
            <a class="active" href="javascript:;">企业</a>
            <a href="javascript:;">政府及第三方机构</a>
          </div>
          <div class="case-list">
            <div class="case case--1"></div>
            <div class="case case--2"></div>
            <div class="case case--3"></div>
            <div class="case case--4"></div>
            <div class="case case--5"></div>
            <div class="case case--6"></div>
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageHeader from "@/components/page-header";
import pageFooter from "@/components/page-footer";
export default {
  name: "business",
  components: {
    pageHeader,
    pageFooter,
  },
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {
  },
};
</script>
<style scoped>
.section {
  margin: 0;
  padding: 0;
  border-radius: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.section .title {
  color: #FFF;
  text-align: center;
  font-family: DIN;
  font-size: 40px;
  font-weight: 700;
}

.section .subtitle {
  margin-top: 40px;
  color: #FFF;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
}

.section--banner {
  height: 800px;
  background-image: url("../../assets/business_banner.png");
}

.section--banner .section-container {
  padding-top: 147px;
  position: relative;
}

.section--banner .img-host {
  text-align: center;
}

.section--banner .img-host img {
  height: 100px;
}

.section--banner .img-wrapper {
  margin-top: 87px;
}

.section--banner .img-pi {
  height: 58px;
  display: block;
}

.section--banner .img-pi-service {
  height: 32px;
  display: block;
  margin-top: 30px;
  position: relative;
  z-index: 1;
}

.section--banner .img-decoration {
  height: 687px;
  position: absolute;
  top: 175px;
  right: 0;
  z-index: 0;
}

.section--banner .btn-contact {
  display: block;
  width: 128px;
  height: 60px;
  margin-top: 60px;
  border-radius: 12px;
  background: #FFF;
  color: #25579A;
  font-size: 18px;
  font-weight: 600;
  line-height: 60px;
  text-align: center;
}

.section--service {
  height: 1080px;
  background-image: url("../../assets/business_service_bg.png");
  position: relative;
}

.section--service .top {
  height: 200px;
  background: linear-gradient(180deg, #000 28.49%, rgba(0, 0, 0, 0.49) 64.25%, rgba(0, 0, 0, 0.00) 100%);
}

.section--service .function-list {
  width: 1200px;
  height: 170px;
  border-radius: 8px;
  border: 1px solid #999;
  background: linear-gradient(69deg, rgba(255, 255, 255, 0.20) 10.42%, rgba(255, 255, 255, 0.04) 77.11%);
  box-shadow: 0px 1.197px 29.915px 0px rgba(69, 42, 124, 0.10);
  backdrop-filter: blur(35px);
  position: absolute;
  left: 50%;
  top: -85px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
}

.section--service .function {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section--service .function .function__img {
  width: 64px;
  height: 64px;
  line-height: 64px;
  text-align: center;
  margin-right: 20px;
}

.section--service .function .function__img img {
  height: 60px;
}

.section--service .function h3 {
  color: #FFF;
  font-size: 24px;
  font-weight: 600;
}

.section--service .function p {
  max-width: 190px;
  margin-top: 10px;
  color: #FFF;
  font-size: 16px;
}

.section--service .service-list {
  margin-top: 90px;
  display: flex;
  flex-wrap: wrap;
}

.section--service .service {
  width: 380px;
  height: 268px;
  background: linear-gradient(110deg, #0C1C44 19.95%, #1E29AA 67.64%, #12366D 107.08%, #323F81 156.61%, #172E61 183.21%);
  border-radius: 15px;
  box-shadow: 4px 7px 26px 0px rgba(0, 0, 0, 0.12);
  padding: 30px 24px;
  margin-right: 30px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.section--service .service:nth-child(3n) {
  margin-right: 0;
}

.section--service .service:nth-child(n+4) {
  margin-top: 40px;
}

.section--service .service:before {
  content: "";
  width: 425px;
  height: 10px;
  background: #5698FC;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.section--service .service:after {
  content: "";
  width: 336px;
  height: 241px;
  background-size: 100% 100%;
  background-image: url("../../assets/business_service_decoration.png");
  position: absolute;
  right: -30px;
  bottom: -40px;
  z-index: 0;
}

.section--service .service h3 {
  margin-bottom: 20px;
  color: #FFF;
  font-size: 24px;
}

.section--service .service p {
  color: #E1E1E1;
  font-size: 14px;
  line-height: 24px;
  position: relative;
  z-index: 1;
}

.section--service .service a {
  padding: 0;
  width: 78px;
  display: block;
  border: 1px solid #2C58E7;
  border-radius: 10px;
  transition: background-color 0.3s;
  position: absolute;
  left: 24px;
  bottom: 30px;
}

.section--service .service a:hover {
  background: #1F22C0;
}

.section--service .service a div {
  height: 32px;
  color: #FFF;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section--solution {
  height: 840px;
  background-image: url("../../assets/business_solution_bg.png");
  position: relative;
  padding-top: 100px;
}

.section--solution .solution-wrapper {
  margin-top: 50px;
  border-radius: 16px;
  background: linear-gradient(110deg, #0C1C44 19.95%, #1E29AA 67.64%, #12366D 107.08%, #323F81 156.61%, #172E61 183.21%);
  box-shadow: 4px 7px 26px 0px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.section--solution .solution-menu {
  display: flex;
}

.section--solution .solution-menu p {
  flex: 1;
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #FFF;
  font-size: 18px;
}

.section--solution .solution-menu p.active {
  background: #005CE7;
}

.section--solution .solution {
  height: 380px;
  display: flex;
  padding: 60px 60px 60px 40px;
  box-sizing: border-box;
  position: relative;
}

.section--solution .solution:after {
  content: "";
  width: 336px;
  height: 241px;
  background-size: 100% 100%;
  background-image: url("../../assets/business_service_decoration.png");
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.section--solution .solution h3 {
  margin-bottom: 20px;
  color: #FFF;
  font-size: 24px;
  font-weight: 600;
}

.section--solution .solution .solution__summary {
  color: #E1E1E1;
  font-size: 16px;
  line-height: 28px;
}

.section--solution .solution .solution__img {
  margin-left: 100px;
  position: relative;
  z-index: 1;
}

.section--solution .solution a {
  width: 108px;
  display: block;
  border: 1px solid #2C58E7;
  border-radius: 10px;
  transition: background-color 0.3s;
  position: absolute;
  left: 40px;
  bottom: 60px;
}

.section--solution .solution a:hover {
  background: #1F22C0;
}

.section--solution .solution a div {
  height: 40px;
  color: #FFF;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section--honor {
  height: 660px;
  background: #15237B url("../../assets/business_honor_bg.png");
  position: relative;
  padding-top: 100px;
}

.section--honor .honor-list {
  margin-top: 110px;
  display: flex;
}

.section--honor .honor {
  flex: 1;
  text-align: center;
}

.section--honor .honor__img {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 37px;
}

.section--honor .honor__title {
  color: #FFF;
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
}

.section--honor .honor__count {
  margin-top: 6px;
  color: #FFF;
  font-size: 32px;
  font-weight: 600;
}

.section--honor .honor__summary {
  max-width: 194px;
  margin: 36px auto 0;
  color: #FFF;
  font-size: 14px;
}

.section--case {
  height: 840px;
  background-image: url("../../assets/business_case_bg.png");
  position: relative;
  padding-top: 100px;
}

.section--case .case-wrapper {
  margin-top: 70px;
}

.section--case .case-menu {
  display: flex;
  align-items: center;
  justify-content: center;
}

.section--case .case-menu a {
  padding: 16px 0;
  color: #FFF;
  font-size: 18px;
}

.section--case .case-menu a.active {
  position: relative;
}

.section--case .case-menu a.active:after {
  content: "";
  width: 36px;
  height: 2px;
  background: #005CE7;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
}

.section--case .case-menu a+a {
  margin-left: 40px;
}

.section--case .case-list {
  border-top: 1px solid #5A5A5A;
  display: flex;
  flex-wrap: wrap;
}

.section--case .case {
  width: calc((100% - 5 * 40px) / 6);
  height: 74px;
  margin-top: 30px;
  margin-right: 40px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.section--case .case:nth-child(6n) {
  margin-right: 0;
}

.section--case .case.case--1 {
  background-image: url("../../assets/business_case_1.png");
}

.section--case .case.case--2 {
  background-image: url("../../assets/business_case_2.png");
}

.section--case .case.case--3 {
  background-image: url("../../assets/business_case_3.png");
}

.section--case .case.case--4 {
  background-image: url("../../assets/business_case_4.png");
}

.section--case .case.case--5 {
  background-image: url("../../assets/business_case_5.png");
}

.section--case .case.case--6 {
  background-image: url("../../assets/business_case_6.png");
}

@media (max-width: 1199px) {
  .section {
    width: 100% !important;
  }

  .section .title {
    color: #FFF;
    text-align: center;
    font-family: DIN;
    font-size: 20px;
    font-weight: 700;
  }

  .section .subtitle {
    margin-top: 10px;
    padding: 0 10px;
    color: #FFF;
    text-align: center;
    font-size: 11px;
    font-weight: 600;
  }

  .section--banner {
    height: 400px;
  }

  .section--banner .section-container {
    padding-top: 60px;
  }

  .section--banner .img-host img {
    height: 40px;
  }

  .section--banner .img-wrapper {
    margin-top: 30px;
    padding-left: 20px;
  }

  .section--banner .img-pi {
    height: 30px;
  }

  .section--banner .img-pi-service {
    height: 20px;
    margin-top: 10px;
  }

  .section--banner .img-decoration {
    height: 300px;
    top: 75px;
  }

  .section--banner .btn-contact {
    width: 100px;
    height: 40px;
    margin-top: 30px;
    margin-left: 20px;
    border-radius: 10px;
    font-size: 14px;
    line-height: 40px;
  }

  .section--service {
    height: auto;
  }

  .section--service .top {
    height: 100px;
  }

  .section--service .function-list {
    width: 95%;
    height: 100px;
    border-radius: 8px;
    top: -50px;
  }

  .section--service .function .function__img {
    width: 40px;
    height: 40px;
    line-height: 40px;
    margin-right: 10px;
  }

  .section--service .function .function__img img {
    height: 30px;
  }

  .section--service .function h3 {
    font-size: 14px;
  }

  .section--service .function p {
    max-width: 190px;
    margin-top: 5px;
    font-size: 11px;
  }

  .section--service .service-list {
    margin-top: 50px;
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 20px;
  }

  .section--service .service {
    width: calc((100% - 30px) * 0.5);
    height: auto;
    border-radius: 10px;
    padding: 15px 12px;
    margin-right: 0;
    margin-left: 10px;
  }

  .section--service .service:nth-child(n+3) {
    margin-top: 10px;
  }

  .section--service .service:before {
    width: 100%;
    height: 5px;
  }

  .section--service .service:after {
    width: 200px;
    height: 143px;
    background-image: url("../../assets/business_service_decoration.png");
    right: 0;
    bottom: 0;
  }

  .section--service .service h3 {
    margin-bottom: 10px;
    font-size: 16px;
  }

  .section--service .service p {
    font-size: 11px;
    line-height: 20px;
  }

  .section--service .service a {
    width: 70px;
    border-radius: 10px;
    margin-top: 10px;
    position: inherit;
    left: auto;
    bottom: auto;
  }

  .section--service .service a div {
    height: 24px;
    font-size: 10px;
  }

  .section--solution {
    height: auto;
    position: relative;
    padding: 50px 10px;
  }

  .section--solution .solution-wrapper {
    margin-top: 30px;
    border-radius: 10px;
  }

  .section--solution .solution-menu p {
    flex: auto;
    white-space: nowrap;
    height: 30px;
    line-height: 30px;
    font-size: 11px;
  }

  .section--solution .solution {
    height: auto;
    display: inherit;
    padding: 10px;
  }

  .section--solution .solution:after {
    width: 200px;
    height: 143px;
  }

  .section--solution .solution h3 {
    margin-bottom: 10px;
    font-size: 18px;
  }

  .section--solution .solution .solution__summary {
    max-width: calc(100% - 160px);
    font-size: 11px;
    line-height: 22px;
  }

  .section--solution .solution .solution__img {
    margin-left: 0;
    position: absolute;
    top: 60px;
    right: 10px;
  }

  .section--solution .solution .solution__img img {
    width: 150px;
  }

  .section--solution .solution a {
    width: 80px;
    border-radius: 10px;
    position: inherit;
    margin-top: 20px;
  }

  .section--solution .solution a div {
    height: 30px;
  }

  .section--solution .solution a div p {
    white-space: nowrap;
  }

  .section--honor {
    height: auto;
    padding: 50px 0;
  }

  .section--honor .honor-list {
    margin-top: 55px;
    flex-wrap: wrap;
  }

  .section--honor .honor {
    flex: auto;
    width: 50%;
  }

  .section--honor .honor:nth-child(n+3) {
    margin-top: 20px;
  }

  .section--honor .honor__img {
    height: 50px;
    margin-bottom: 10px;
  }

  .section--honor .honor__img img {
    width: 40px;
  }

  .section--honor .honor__title {
    font-size: 14px;
  }

  .section--honor .honor__count {
    margin-top: 0;
    font-size: 18px;
  }

  .section--honor .honor__summary {
    max-width: 130px;
    margin: 10px auto 0;
    font-size: 11px;
  }

  .section--case {
    height: auto;
    padding: 50px 0;
  }

  .section--case .case-wrapper {
    margin-top: 30px;
  }

  .section--case .case-menu a {
    padding: 10px 0;
    font-size: 14px;
  }

  .section--case .case-menu a.active:after {
    width: 24px;
    height: 1px;
  }

  .section--case .case-menu a+a {
    margin-left: 20px;
  }

  .section--case .case {
    width: calc((100% - 3 * 10px) * 0.5);
    height: 60px;
    background-size: cover;
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 0;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/business/business.vue